
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
const common_app = namespace("common_app");

@Component({})
export default class Template extends Vue {
  @common_app.State lang;
  @common_app.State country;
  @Prop({ default: "language", type: String }) // language | country
  mode: string;
  @Prop({ default: null, type: Object })
  loaderData: any;
  @Prop({ default: "100%", type: String })
  width: string;
  src: any = "";
  created() {
    this.getSrc();
  }
  getSrc() {
    if (this.loaderData) {
      if (this.mode === "language") {
        this.src = this.loaderData[this.lang];
      } else {
        if (typeof this.loaderData[this.country] === "string") {
          this.src = this.loaderData[this.country];
        } else {
          this.src = this.loaderData[this.country][this.lang];
        }
      }
    }
  }
}
